import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import SoftBadge from 'components/common/SoftBadge';
import { useToast } from 'context/providers/ToastProvider';
import { Card, Col, Form, Row, Spinner, Table } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';
import AgregarProducto from './AgregarProducto';



const DetalleProducto = () => {

    const { id } = useParams();
    const { showErrorToast } = useToast();
    const { token, setToken } = useToken();
    const [producto, setProducto] = useState({});
    const [renovaciones, setRenovaciones] = useState([]);
    const [editar, setEditar] = useState(false)
    const [cargando, setCargando] = useState(true);
    const navigate = useNavigate();
    const [imagenProducto, setImagenProducto] = useState({
        file: null,
        fileName: ''
    });
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');


    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        informacionDetalladaProducto();
    }, []);


    /**
    * Divide dCreatedDate en fecha y hora por separados
    */
    useEffect(() => {
        if (producto.dCreatedDate) {
            const [fechaParte, horaParte] = producto.dCreatedDate.split("T");
            setFecha(fechaParte); // Guardar la fecha
            setHora(horaParte.split(".")[0]); // Guardar la hora (eliminando los milisegundos)
        }
    }, [producto.dCreatedDate]);

    useEffect(() => {
        if (Array.isArray(renovaciones) && renovaciones.length > 0) {
            console.log("✅ Renovaciones actualizadas:", renovaciones);
            console.table(renovaciones);
        } else {
            console.warn("⚠️ Renovaciones vacías o no válidas:", renovaciones);
        }
    }, [renovaciones]);
    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        // Validar si no hay imagen
        if (!base64String) return null;

        try {
            // Extraer el contenido Base64 de manera segura
            const base64Data = base64String?.split(',')[1] || base64String;

            // Validar formato Base64
            if (!/^[A-Za-z0-9+/=]*$/.test(base64Data)) {
                console.error('Formato Base64 inválido');
                return null;
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const mimeType = base64String.split(';')[0]?.split(':')[1] || 'image/jpeg';

            return new File([new Blob([byteArray], { type: mimeType })], fileName, {
                type: mimeType,
                lastModified: Date.now()
            });

        } catch (error) {
            console.error('Error al convertir Base64 a File:', error);
            return null;
        }
    };

    /**
     * obtiene informacion de un producto
     */
    const informacionDetalladaProducto = async () => {


        setCargando(true);

        var objDataSend = {};

        objDataSend.idProducto = id;

        console.log(objDataSend, 'ID DEL PRODUCTO');
        var jDataSend = JSON.stringify(objDataSend);


        const response = await fetch("/api/Productos/DetalleProducto", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {

            console.log("===================== informacionDetalladaProducto =========================");

            console.log(response);
            const data = await response.json();

            console.log("===================== RESPONSETYPE =========================", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);


                setProducto(ObjDetalles.table2[0]);

                console.log("Tabla 3:", ObjDetalles.table3);

                const renovacionesArray = Array.isArray(ObjDetalles.table3)
                    ? ObjDetalles.table3
                    : Object.values(ObjDetalles.table3 || {});


                setRenovaciones(renovacionesArray);


                // Convertir archivo a imagen desde el base 64
                const file_jpg = ObjDetalles.table2[0]?.vImagenProducto_Base64
                    ? base64ToFile(
                        ObjDetalles.table2[0].vImagenProducto_Base64,
                        ObjDetalles.table2[0].vImagenProducto_Name
                    )
                    : null;

                // Actualizar estado de la imagen
                let producto_ = ObjDetalles.table2[0] || {};
                producto_.filejpg = file_jpg;
                setImagenProducto({
                    fileName: producto_.vImagenProducto_Name || 'sin-imagen',
                    file: file_jpg ? URL.createObjectURL(file_jpg) : null
                });


            } else {

                showErrorToast(data.vMessage);
            }
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);
    };

    console.log("===================== informacionDetalladaProducto =========================", producto);


    return (
        <>

            <PageHeader
                title={"Producto " + id + " | Informaci\u00f3n detallada"}
                className="mb-1"
            ></PageHeader>
            {cargando ?
                <h3>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h3>
                :
                <>
                    <Card className="mb-1">
                        <Card.Header className="d-flex flex-between-center">
                            <IconButton
                                onClick={() => navigate(-1)}
                                variant="falcon-default"
                                size="sm"
                                icon="arrow-left"
                            />
                            <Flex>
                                {producto &&
                                    (<>
                                        {!editar &&
                                            <>
                                                <IconButton
                                                    onClick={() => { setEditar(true); }}

                                                    variant="falcon-default"
                                                    size="sm"
                                                    icon="pencil-alt"
                                                    transform="shrink-2"
                                                    className="d-sm-block me-2"
                                                >
                                                    <span className="d-none d-xl-inline-block ms-1">Editar detalles</span>
                                                </IconButton>
                                            </>
                                        }
                                    </>)
                                }

                            </Flex>


                        </Card.Header>
                    </Card>
                    {!editar ? (
                        <Form>
                            <Row className="g-3 mb-3">
                                <Col lg={12}>
                                    {/* Información general */}
                                    <Card>
                                        <Card.Body className="border-top fs--1">
                                            <div className="container mt-5">
                                                <div className="row">
                                                    {/* Columna de Imagen */}
                                                    <Col lg={5} className="mb-4">
                                                        {/* Contenedor Imagen */}
                                                        <div className="text-center mb-4">
                                                            <div
                                                                className="mx-auto"
                                                                style={{
                                                                    width: '400px',
                                                                    height: '400px',
                                                                    backgroundColor: '#f8f9fa',
                                                                    borderRadius: '0.5rem',
                                                                    overflow: 'hidden',
                                                                    position: 'relative',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                            >
                                                                {imagenProducto.file ? (
                                                                    <img
                                                                        src={imagenProducto.file}
                                                                        alt={producto.vCodigoBarras}
                                                                        className="w-100 h-100"
                                                                        style={{ objectFit: 'cover' }}
                                                                    />
                                                                ) : (
                                                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                                                        <i className="bi bi-box-seam text-muted fs-1"></i>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* Información de creación / modificación */}
                                                        <Row className="mt-3">
                                                            <Flex>
                                                                <FontAwesomeIcon
                                                                    icon="user"
                                                                    className="text-success me-2"
                                                                    transform="down-5"
                                                                />
                                                                <div className="flex-1">
                                                                    El producto fue registrado el &nbsp;
                                                                    <SoftBadge bg="primary" className="me-2">
                                                                        {fecha}
                                                                    </SoftBadge>
                                                                    &nbsp;a las &nbsp;
                                                                    <SoftBadge bg="primary" className="me-2">
                                                                        {hora}
                                                                    </SoftBadge>
                                                                    &nbsp;por &nbsp;
                                                                    <SoftBadge bg="success" className="me-2">
                                                                        {producto.vCreatedUser}.
                                                                    </SoftBadge>
                                                                </div>
                                                            </Flex>
                                                            {producto.vUpdatedUser && (
                                                                <Flex className="mt-2">
                                                                    <FontAwesomeIcon
                                                                        icon="user"
                                                                        className="text-primary me-2"
                                                                        transform="down-5"
                                                                    />
                                                                    <div className="flex-1">
                                                                        La última modificación la realizó:&nbsp;
                                                                        <SoftBadge bg="success" className="me-2">
                                                                            {producto.vUpdatedUser}
                                                                        </SoftBadge>
                                                                    </div>
                                                                </Flex>
                                                            )}
                                                        </Row>
                                                    </Col>

                                                    {/* Columna de Detalles */}
                                                    <Col md={7}>
                                                        <h2>{producto.vNombreProducto}</h2>
                                                        {producto.idCatDepartamento === 0 ? (
                                                            <p>Este producto no tiene comisión.</p>
                                                        ) : producto.idCatDepartamento === 1 ? (
                                                            <p>Este producto tiene comisión.</p>
                                                        ) : (
                                                            <p>Este producto tiene comisión parcial del 30%.</p>
                                                        )}

                                                        {/* Sección principal de precios/renovaciones */}
                                                        <div className="mt-4">
                                                            {renovaciones && renovaciones.length > 0 ? (
                                                                <>


                                                                    {/* Cards apiladas verticalmente ocupando todo el ancho */}
                                                                    <div className="d-flex flex-column gap-3">
                                                                        {renovaciones.map((renovacion, index) => (
                                                                            <Card key={index} className="border-primary w-100">
                                                                                <Card.Header className="bg-primary text-white">
                                                                                    <p className="mb-0 fs-1">Renovación {renovacion.tipo}</p>
                                                                                </Card.Header>
                                                                                <Card.Body>
                                                                                    <Row>
                                                                                        <Col md={3} className="text-center">
                                                                                            <h3 className="text-primary mb-0">
                                                                                                ${renovacion.total?.toFixed(2) || '0.00'}
                                                                                            </h3>
                                                                                            <small className="text-muted">Precio Total</small>
                                                                                            <div>
                                                                                                <small className="text-muted">{renovacion.priceId}</small>
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col md={9}>
                                                                                            <Row>
                                                                                                <Col md={6}>
                                                                                                    <Table size="sm" borderless>
                                                                                                        <tbody>
                                                                                                            <tr>
                                                                                                                <td className="fw-bold">Precio Base:</td>
                                                                                                                <td className="text-success">
                                                                                                                    ${renovacion.preciounitario?.toFixed(2) || '0.00'}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                            <tr>
                                                                                                                <td className="fw-bold">IVA:</td>
                                                                                                                <td className="text-warning-dark">
                                                                                                                    ${renovacion.iva?.toFixed(2) || '0.00'}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </tbody>
                                                                                                    </Table>
                                                                                                </Col>
                                                                                                <Col md={6}>
                                                                                                    <Table size="sm" borderless>
                                                                                                        <tbody>
                                                                                                            <tr>
                                                                                                                <td className="fw-bold">Tipo Factor:</td>
                                                                                                                <td>{renovacion.tipofactoriva || 'Exento'}</td>
                                                                                                            </tr>
                                                                                                            <tr>
                                                                                                                <td className="fw-bold">
                                                                                                                    {renovacion.tipofactoriva === 'Tasa'
                                                                                                                        ? '% IVA'
                                                                                                                        : ''}


                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {renovacion.tipofactoriva === 'Tasa'
                                                                                                                        ? (renovacion.tasacuotaiva * 100) + '%'
                                                                                                                        : ''}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </tbody>
                                                                                                    </Table>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            {renovacion.dFecha && (
                                                                                                <div className="mt-2">
                                                                                                    <small className="text-muted">
                                                                                                        <i className="fas fa-calendar me-1"></i>
                                                                                                        Fecha: {new Date(renovacion.dFecha).toLocaleDateString()}
                                                                                                    </small>
                                                                                                </div>
                                                                                            )}
                                                                                        </Col>

                                                                                    </Row>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <h2 className="text-primary">${producto.dTotal}</h2>
                                                                    {producto.bServicio && producto.dExistencia === 0 ? (
                                                                        <p>Este producto es un servicio.</p>
                                                                    ) : !producto.bServicio && producto.dExistencia === 0 ? (
                                                                        <p>Existencia: {producto.dExistencia} (Producto inventariado sin stock)</p>
                                                                    ) : (
                                                                        <p>Existencia: {producto.dExistencia}</p>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>

                                                        {/* Sección de información técnica - Solo mostrar si NO hay renovaciones */}
                                                        {(!renovaciones || renovaciones.length === 0) && (
                                                            <div className="mt-1">
                                                                <Row className="g-3 mt-3">
                                                                    <Col lg={12}>
                                                                        <Card className="h-100">
                                                                            <Card.Body className="p-2">
                                                                                <Table borderless className="font-sans-serif mb-0">
                                                                                    <tbody>
                                                                                        <tr className="border-bottom">
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">Código de Barras</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="120px" />
                                                                                                ) : (
                                                                                                    <span className="text-1100">
                                                                                                        {producto?.vCodigoBarras || '-'}
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr className="border-bottom">
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">Precio Base</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="80px" />
                                                                                                ) : (
                                                                                                    <span className="text-success fw-bold">
                                                                                                        ${producto?.dPrecioUnitario?.toFixed(2) || '0.00'}
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr className="border-bottom">
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">Clave Unidad</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="100px" />
                                                                                                ) : (
                                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                                        <span className="badge bg-primary">
                                                                                                            {producto?.vClaveUnidadSat +
                                                                                                                producto.vDescripcion_ClaveUnidad || 'N/A'}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">Clave Producto/Servicio</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="150px" />
                                                                                                ) : (
                                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                                        <span className="badge bg-info">
                                                                                                            {producto?.vCodigoProductoServicioSat || 'N/A'}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>

                                                                    <Col lg={12}>
                                                                        <Card className="h-100">
                                                                            <Card.Body className="p-2">
                                                                                <Table borderless className="font-sans-serif mb-0">
                                                                                    <tbody>
                                                                                        <tr className="border-bottom">
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">Tipo Factor IVA</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="100px" />
                                                                                                ) : (
                                                                                                    <span className="text-1100">
                                                                                                        {producto?.vTipoFactorIVA || 'Exento'}
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr className="border-bottom">
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">IVA Total</td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="80px" />
                                                                                                ) : (
                                                                                                    <span className="text-warning-dark fw-bold">
                                                                                                        ${producto?.dIVA?.toFixed(2) || '0.00'}
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td className="py-2 bg-100 text-900 fw-semi-bold">
                                                                                                Porcentaje de {producto.vTipoFactorIVA}
                                                                                            </td>
                                                                                            <td className="py-2">
                                                                                                {cargando ? (
                                                                                                    <Skeleton width="60px" />
                                                                                                ) : (
                                                                                                    <span className="text-warning-dark fw-bold">
                                                                                                        {producto.vTipoFactorIVA === 'Tasa'
                                                                                                            ? (producto.dTasaCuotaIVA * 100) + '%'
                                                                                                            : producto.dTasaCuotaIVA}
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        )}
                                                    </Col>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Form>

                    ) : (
                        <AgregarProducto
                            productos={producto}
                            renovaciones={renovaciones}
                        />
                    )}
                </>
            }

        </>

    );
};

export default DetalleProducto;